module.exports = __webpack_public_path__ + "static/media/31.fc317813.mp3";